import React from 'react';

import { useController, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { Input } from '@material-ui/core';
import { ErrorMessage } from '@hookform/error-message';
import PropTypes from 'prop-types';

import useStyles from 'pages/FundingNotes/useStyles';

export const DecimalInputCell = props => {
  const { name, childrenProps } = props;
  const methods = useFormContext();
  const { control, errors } = methods;
  const classes = useStyles();
  const {
    field: { ref, onChange, ...inputProps },
  } = useController({
    name,
    control,
  });

  const handleValueChange = values => {
    const { value } = values;
    onChange(value);
  };

  return (
    <div className={classes.inputCellWrap}>
      <NumberFormat
        name={name}
        decimalScale={2}
        type="text"
        thousandSeparator=","
        customInput={Input}
        onValueChange={handleValueChange}
        autoComplete="off"
        className={classes.input}
        inputRef={ref}
        {...inputProps}
        {...childrenProps}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <p className={classes.errorMessage}>{message}</p>}
      />
    </div>
  );
};

DecimalInputCell.propTypes = {
  name: PropTypes.string,
  childrenProps: PropTypes.shape(),
};
